import EnhancedRoute from './Enhanced.route';

export default EnhancedRoute;
